import React, { useEffect, useState } from "react";
import { Chevron } from "components/icons/chevron";
import {
  AccordionContent,
  AccordionItem,
  AccordionSubTitle,
  AccordionTitle,
  AccordionTitleWrapper,
  ChevronWrapper
} from "./accordion.styles";
import { AccordionProps } from "./accordion.types";

const Accordion: React.FC<AccordionProps> = ({
  title,
  content,
  subTitle,
  isDisabled = false,
  isBordered = false,
  collapsed,
  onClick = () => {}
}) => {
  const [isCollapse, setIsCollapse] = useState(isDisabled);

  useEffect(() => {
    setIsCollapse(isDisabled);
  }, [isDisabled]);

  return (
    <AccordionItem isDisabled={isDisabled} isBordered={isBordered}>
      <AccordionTitleWrapper
        isBordered={isBordered}
        onClick={
          isDisabled
            ? () => null
            : () => {
                setIsCollapse((prevState) => !prevState);
                onClick(!isCollapse);
              }
        }
      >
        <div>
          <AccordionTitle
            isCollapse={collapsed !== undefined ? collapsed : isCollapse}
          >
            {title}
          </AccordionTitle>
          {subTitle && <AccordionSubTitle>{subTitle}</AccordionSubTitle>}
        </div>
        {!isDisabled && (
          <ChevronWrapper isCollapse={isCollapse}>
            <Chevron />
          </ChevronWrapper>
        )}
      </AccordionTitleWrapper>
      <AccordionContent
        isCollapse={isDisabled || isCollapse}
        isBordered={isBordered}
      >
        {content}
      </AccordionContent>
    </AccordionItem>
  );
};

export { Accordion };
